<template>
  <div class="home-page">
    <h1>{{ welcomeMessage }}</h1>
    <p>Welcome to our new website!</p>
    <button @click="incrementCount">Click me: {{ count }}</button>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  data() {
    return {
      welcomeMessage: 'Hello, Vue!',
      count: 0
    };
  },
  methods: {
    incrementCount() {
      this.count++;
    }
  }
};
</script>

<style scoped>
.home-page {
  text-align: center;
  margin-top: 50px;
  font-family: sans-serif;
}
h1 {
  color: #42b883;
}
</style>
